import { getUserInitialState } from "./userSlice";

export const migrations = {
	2: (state: any): any => {
		if (!state.users.sortPreferences) {
			state.users.sortPreferences = getUserInitialState().sortPreferences;
		}
		return state;
	},
	3: (state: any): any => {
		if (!state.users.isCoAppSuperAdmin) {
			state.users.isCoAppSuperAdmin = getUserInitialState().isCoAppSuperAdmin;
		}
		if (!state.users.organizationName) {
			state.users.organizationName = getUserInitialState().organizationName;
		}
		return state;
	},
	4: (state: any): any => {
		if (!state.users.organizationFailedSyncBehavior) {
			state.users.organizationFailedSyncBehavior = getUserInitialState().organizationFailedSyncBehavior;
		}
		return state;
	},
	5: (state: any): any => {
		if (!state.users.descopeUserId) {
			state.users.descopeUserId = getUserInitialState().descopeUserId;
		}
		return state;
	},
	12: (state: any): any => {
		// Introduce per-grid user preferences (column visibility, etc.).
		if (!state.dataGridPrefs) {
			state.dataGridPrefs = { columnVisibility: {} };
		}
		return state;
	},
	13: (state: any): any => {
		// Drop the legacy "Build Rule" sidebar nav entry — the action lives in
		// the page header now.
		if (state?.navigation?.navState && Array.isArray(state.navigation.navState)) {
			state.navigation.navState = state.navigation.navState.filter(
				(item: any) => !(item?.name === "Build Rule")
			);
		}
		return state;
	},
	14: (state: any): any => {
		const defaults = getUserInitialState().sortPreferences;
		state.users.sortPreferences = {
			...defaults,
			...(state.users?.sortPreferences ?? {}),
		};
		return state;
	},
};
